import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, FormLabel, Grid, InputAdornment } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from '../../../components/Common/Notification';
import CustomButton from "../../../components/Form/CustomButton";
import CustomTextField from "../../../components/Form/CustomTextField";
import RadioButtonGroup from "../../../components/Form/RadioButtonGroup";
import { createShipping, getGeneral, getShippingDetails, resetShippingState, updateShipping } from "../../../store/actions";

const AddShippingMethod = ({ type, title, editShipping, addShipping, shippingDetails, country, shippingAdd }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fileInputRef = useRef();
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    useEffect(() => {
        dispatch(resetShippingState())

        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (type === "Edit") {
            if (ID) {
                setIsLoading(true)
                dispatch(getShippingDetails({ id: ID }))
                setIsLoading(false)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (type === "Edit") {
            if (ID) {
                const filtered = shippingDetails || []
                if (filtered) {
                    setFormValues({
                        shipping_group_id: filtered?.descriptions?.[0]?.shipping_group_id,
                        type: filtered?.descriptions?.[0].type || "",
                        title: filtered?.descriptions?.[0].title || "",
                        description: filtered?.descriptions?.[0].description || "",
                        from_day: filtered?.descriptions?.[0].from_day,
                        to_day: filtered?.descriptions?.[0].to_day,
                        status: filtered.status,
                        sort_order: filtered.sort_order,
                    })
                }
            }
        }
    }, [shippingDetails]);

    useEffect(() => {
        if (type === "Edit") {
            if (editShipping?.code === "success") {
                setNotification({
                    open: true,
                    msg: "Updated Successfully",
                    type: "success",
                })
                dispatch(resetShippingState());
                dispatch(getGeneral())
                dispatch(getShippingDetails({ id: ID }));
            }
        }
    }, [editShipping]);

    useEffect(() => {
        if (type === "Add") {
            if (addShipping?.code === "success") {
                setNotification({
                    open: true,
                    msg: "Added Successfully",
                    type: "success",
                })
                dispatch(resetShippingState())
                dispatch(getGeneral())
                navigate("/settings-shipping-methods")
            } else if (addShipping?.[0]?.address) {
                setNotification({
                    open: true,
                    msg: addShipping?.[0]?.address,
                    type: "warning",
                })
            }
        }
    }, [addShipping]);

    const handleSubmit = (type) => {
        if (type === "Add") {
            dispatch(createShipping(values))
        }
        else if (type === "Edit") {
            dispatch(updateShipping({ id: ID, shipping: values }))
        }

    }

    const defaultValues = {
        shipping_group_id: "",
        type: "",
        title: "",
        description: "",
        from_day: "",
        to_day: "",
        status: 1
    }

    const { ID } = useParams()

    const [values, setFormValues] = useState(defaultValues);
    const [loading, setIsLoading] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);

    const data = [
        { value: 1, label: "Active" },
        { value: 0, label: "Inactive" },
    ]

    const error = shippingAdd?.[0];
    return (
        <React.Fragment>
            {
                width <= 425 &&
                <div className="mobile-button-container">
                    <CustomButton
                        title={type === 'Add' ? 'Save' : 'Save Changes'}
                        press={() => handleSubmit(type)}
                        height={40}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        width={'100%'}
                    />
                </div>
            }
            <div className="page-content">
                <Container fluid>
                    <LoadingDialog open={loading || !shippingDetails} />
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumbs
                        backRoute={"/settings-shipping-methods"}
                        breadcrumbItems={[{ title: "Shipping Methods", link: "/settings-shipping-methods" },
                        { title: title, link: "#" },
                        ]}
                    >
                        {
                            width > 425 &&
                            <CustomButton
                                title={type === 'Add' ? 'Save' : 'Save Changes'}
                                press={() => handleSubmit(type)}
                                height={40}
                                backgroundColor={'#101010'}
                                textColor={'white'}
                            />
                        }
                    </Breadcrumbs>
                    <Grid container spacing={2}>
                        <Grid item sm={12} lg={8} pb={3}>
                            <Card className="p-3 px-2">
                                <CardBody>
                                    <div className="setting-header">BASIC INFO</div>
                                    <Divider className="my-2 mb-4" />
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <RadioButtonGroup
                                                title={'Type'}
                                                value={values.type}
                                                data={[{ value: 1, label: "Delivery" }, { value: 2, label: "Pick up" }]}
                                                setValue={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    type: e,
                                                }))}
                                                required="true"
                                                name="type"
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.type || ""}</FormHelperText>}
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <CustomTextField
                                                title={'Method name'}
                                                values={values?.title}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    title: e
                                                }))}
                                                placeholder="E.g. Standard Delivery"
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.title || ""}</FormHelperText>}
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <CustomTextField
                                                title={'Description'}
                                                values={values?.description}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    description: e
                                                }))}
                                                multiline={true}
                                                rows={4}
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.description || ""}</FormHelperText>}
                                        </Grid>
                                        {
                                            (`${values?.type}` !== "2") &&
                                            <Grid item xs={12} sm={12} md={6}>
                                                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Estimated shipping time</FormLabel>
                                                <div className="d-flex align-items-center">
                                                    <CustomTextField
                                                        values={values?.from_day}
                                                        onChange={(e) => setFormValues((prevValues) => ({
                                                            ...prevValues,
                                                            from_day: e
                                                        }))}
                                                        placeholder={'0'}
                                                        InputProps={{
                                                            endAdornment: <InputAdornment position="end"><span style={{ color: '#999999' }}>days</span></InputAdornment>,
                                                        }}
                                                        type="number"
                                                        error={error && error?.from_day}
                                                    />
                                                    <div className="mx-2"> - </div>
                                                    <CustomTextField
                                                        values={values?.to_day}
                                                        onChange={(e) => setFormValues((prevValues) => ({
                                                            ...prevValues,
                                                            to_day: e
                                                        }))}
                                                        placeholder={'0'}
                                                        InputProps={{
                                                            endAdornment: <InputAdornment position="end"><span style={{ color: '#999999' }}>days</span></InputAdornment>,
                                                        }}
                                                        type="number"
                                                        error={error && error?.to_day}
                                                    />
                                                </div>
                                            </Grid>
                                        }
                                    </Grid>
                                </CardBody>
                            </Card>
                        </Grid>
                        <Grid container item sm={12} lg={4}>
                            <Grid item xs={12} sm={12}>
                                <Card className="p-3 px-2">
                                    <CardBody>
                                        <div className="setting-header">SETTINGS</div>
                                        <Divider className="my-2 mb-4" />
                                        <div className="mt-3">
                                            <RadioButtonGroup
                                                title={'Status'}
                                                value={parseInt(values?.status)}
                                                data={data}
                                                setValue={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    status: e,
                                                }))}
                                                required="true"
                                                name="status"
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>}
                                        </div>
                                        <div className="mt-3">
                                            <CustomTextField
                                                title={'Sort order'}
                                                values={values?.sort_order}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    sort_order: e
                                                }))}
                                                error={error && error?.sort_order}
                                                type={'number'}
                                                placeholder={'0'}
                                            />
                                        </div>
                                        {/* {
                                            type === 'Edit' &&
                                            <>
                                                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Last modified</FormLabel>
                                                <div>10 Oct 2024, 03:14 PM</div>
                                            </>
                                        } */}
                                    </CardBody>
                                </Card>

                            </Grid>
                        </Grid>
                    </Grid>
                    {/* </CardBody>
                    </Card> */}
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ General, Shipping }) {
    return {
        shippingDetails: Shipping.shippingDetails,
        shippingAdd: Shipping.error,
        addShipping: Shipping.addShipping,
        editShipping: Shipping.updateShipping,
        country: General.countries,
        countryWithoutMlys: General.countries.filter((el) => el.id != 129),
    };
}

export default connect(mapStateToProps)(AddShippingMethod);
